module.exports = __webpack_public_path__ + "img/rifle.ak.2995eaf1.png";